export class Traces {
 
  x: number[] = [];
  y: number[] = [];
  mode: string;
  type: string;
  hovertemplate: string;
  name: string;
  text: string[];
  cliponaxis: boolean;
  marker: {
    color: string,
    size: number
  };
  entityId: string;
  alertCount: number;
  uniqueId: string;
  constructor(x: number, y: number, name: string, color: string, size: number, id: string, alertCount: number, lastSeentime: string, uniqueId: string) {
    this.x.push(x);
    this.y.push(y);
    this.mode = 'markers';
    this.type = 'scatter';
    this.name = name;
    this.text = [name];
    this.hovertemplate = 'Entity : ' + uniqueId + '<br> Alerts : ' + alertCount + ' <br> Last Active : ' + lastSeentime + ' <extra></extra>';
    this.marker = { color: color, size: size };
    this.cliponaxis = false;
    this.entityId = id;
  }
}